import { combineReducers } from 'redux';
import userRedux from './userRedux';
import workspaceRedux from './workspaceRedux';

const rootReducer = (state, action) => combineReducers({
  userRedux: userRedux,
  workspaceRedux: workspaceRedux
})(state, action);

export default rootReducer;